import { useEffect, useRef } from 'react'

const STEP_ICONS = {
  planning: '🧠',
  designing: '🎨',
  building: '🔨',
  writing: '✏️',
  coding: '⚡',
  testing: '🧪',
  styling: '💅',
  done: '✅',
  error: '❌',
}

export default function BuildLog({ steps, isBuilding, currentStatus }) {
  const bottomRef = useRef(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [steps])

  if (!isBuilding && steps.length === 0) return null

  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--r)',
      overflow: 'hidden',
      marginBottom: 12,
    }}>
      <div style={{
        padding: '8px 12px',
        borderBottom: '1px solid var(--border)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        background: 'var(--panel)',
      }}>
        {isBuilding && <span style={{ width: 7, height: 7, background: 'var(--fire)', borderRadius: '50%', animation: 'blink 1s infinite', display: 'inline-block' }} />}
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--text2)', letterSpacing: 1.5, textTransform: 'uppercase' }}>Build Log</span>
      </div>
      <div style={{ maxHeight: 180, overflowY: 'auto', padding: '8px 0' }}>
        {steps.map((step, i) => (
          <div key={i} style={{
            padding: '4px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            opacity: i === steps.length - 1 ? 1 : 0.6,
          }}>
            <span style={{ fontSize: 12 }}>{STEP_ICONS[step.type] || '•'}</span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: i === steps.length - 1 ? 'var(--text)' : 'var(--text2)' }}>
              {step.text}
            </span>
            {step.done && <span style={{ marginLeft: 'auto', color: 'var(--green)', fontSize: 10 }}>✓</span>}
          </div>
        ))}
        {isBuilding && (
          <div style={{ padding: '4px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 12 }}>⚙️</span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--fire)' }}>{currentStatus}</span>
            <span style={{ marginLeft: 4 }}>
              {[0,1,2].map(i => (
                <span key={i} style={{ display: 'inline-block', width: 4, height: 4, background: 'var(--fire)', borderRadius: '50%', margin: '0 2px', animation: `td 1.2s ${i*0.2}s infinite` }} />
              ))}
            </span>
          </div>
        )}
        <div ref={bottomRef} />
      </div>
    </div>
  )
}
